var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function fn(_ref) {
            var on = _ref.on,
              attrs = _ref.attrs
            return [
              _c(
                "gg-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "mt-1",
                      attrs: {
                        dark: "",
                        tile: "",
                        color: "primary"
                      }
                    },
                    "gg-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [_vm._v(" Add a new account ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "v-list",
        _vm._l(_vm.groupLinks, function(item, index) {
          return _c(
            "v-list-item",
            {
              key: index,
              staticStyle: {
                cursor: "pointer"
              }
            },
            [
              _c(
                "v-list-item-title",
                {
                  on: {
                    click: function click($event) {
                      return _vm.followLink(item.href)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(item.title) + " ")]
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }